import { motion } from "framer-motion";
import { ShieldCheck, Clock, RefreshCcw, Headphones } from "lucide-react";

/* GuaranteeSection — Garantia premium com checklist de promessas */
const guarantees = [
  { icon: ShieldCheck, title: "Devolução total",   desc: "100% do valor de volta, sem questionamentos" },
  { icon: Clock,       title: "7 dias corridos",   desc: "A partir da data de confirmação do pagamento" },
  { icon: RefreshCcw,  title: "Sem burocracia",    desc: "Processo simples e rápido, sem complicações" },
  { icon: Headphones,  title: "Suporte incluso",   desc: "Atendimento disponível durante o período de garantia" },
];

export function GuaranteeSection() {
  return (
    <section className="py-16 sm:py-24 bg-background relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-accent/5 via-transparent to-transparent pointer-events-none" />

      <div className="container max-w-4xl mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="bg-card border-2 border-accent/20 rounded-3xl p-7 sm:p-10 md:p-14 text-center relative overflow-hidden"
        >
          <div className="absolute -top-12 -right-12 w-40 sm:w-48 h-40 sm:h-48 bg-accent/10 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute -bottom-12 -left-12 w-40 sm:w-48 h-40 sm:h-48 bg-primary/10 rounded-full blur-3xl pointer-events-none" />

          <div className="relative z-10">
            {/* Ícone grande com anel pulsante */}
            <div className="relative inline-flex items-center justify-center mb-6">
              <motion.div
                animate={{ scale: [1, 1.12, 1], opacity: [0.3, 0.15, 0.3] }}
                transition={{ repeat: Infinity, duration: 3 }}
                className="absolute w-24 sm:w-28 h-24 sm:h-28 rounded-full bg-accent/20"
              />
              <div className="relative w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-accent/10 border-2 border-accent/30 flex items-center justify-center">
                <ShieldCheck className="w-8 h-8 sm:w-10 sm:h-10 text-accent" />
              </div>
            </div>

            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-foreground mb-3">
              Garantia de 7 dias
              <span className="text-accent"> incondicional</span>
            </h2>

            <p className="text-sm sm:text-base md:text-lg text-muted-foreground leading-relaxed mb-2 max-w-xl mx-auto">
              Se em 7 dias você não considerar esta plataforma essencial ao seu plantão, devolvemos{" "}
              <span className="text-accent font-bold">100% do seu investimento</span>.{" "}
              <span className="font-bold text-foreground">Sem perguntas.</span>
            </p>

            {/* Grid de promessas */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 mt-8 sm:mt-10">
              {guarantees.map((item, i) => {
                const Icon = item.icon;
                return (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.08 }}
                    className="bg-background border border-border rounded-2xl p-3 sm:p-4 text-center"
                  >
                    <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-accent mx-auto mb-2" />
                    <div className="font-semibold text-foreground text-xs sm:text-sm mb-0.5">{item.title}</div>
                    <div className="text-xs text-muted-foreground leading-tight">{item.desc}</div>
                  </motion.div>
                );
              })}
            </div>

            <p className="text-xs text-muted-foreground mt-5 sm:mt-6">
              Garantia válida por 7 dias corridos a partir da data de compra.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
